import { HOST_URL } from '@marketplace/common';

const API = HOST_URL + '/api';

export const API_ROUTES = {
  ATTRIBUTES: `${API}/attributes`,
  DEVELOPERS: `${API}/developers`,
  APPLICATIONS: `${API}/applications`,
  APPLICATIONS_PUBLIC: `${API}/applications_public`,
  PRODUCT: `${API}/products`,
  COMMON: `${API}/common`,
  SECRET: `${API}/developers/get-sandbox-credentials`,
  EXTERNAL_ID: `${API}/developers/external-id`,
};

export const ERROR_CODES = {
  EMAIL_UNIQUES: '3004',
  APP_NAME_UNIQUES: '1018',
  APPLICATION_ALREADY_EXIST: '3003',
  DEPENDENCY_FAILED:'1019',
  EMAIL_ALREADY_EXTSTS_IN_BOTH_GIS_AND_DP_DATABASE: '3008',
  EMAIL_ALREADY_EXTSTS_IN_GIS_DATABASE_NOT_IN_DP_DATABASE: '3009',
  EMAIL_ALREADY_EXTSTS_IN_DP_DATABASE_NOT_IN_GIS_DATABASE: '3010',
};
